module.exports = __webpack_public_path__ + "img/9788982735493.f65532e6.jpg";